import React, { forwardRef, useContext } from 'react';
import {
  IAlignItemsProps,
  IGapProps,
  IJustifyContentProps,
  TGridAdaptive,
  TGridSizeAdaptive,
  TSpaceAdaptive,
} from '@src/models/adaptive';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';
import styled from './Grid.scss';

interface IProps extends IDefaultComponentProps, IAlignItemsProps, IJustifyContentProps, IGapProps {
  /** Количество колонок для каждого из размеров экрана. */
  columns?: TGridAdaptive;

  /** Количество строк для каждого из размеров экрана. */
  rows?: TGridAdaptive;

  /** Начальная позиция контейнера */
  colStart?: TGridSizeAdaptive;

  /** Конечная позиция контейнера */
  colEnd?: TGridSizeAdaptive;

  /** Начальная позиция контейнера */
  rowStart?: TGridSizeAdaptive;

  /** Конечная позиция контейнера */
  rowEnd?: TGridSizeAdaptive;

  /** Отступ между строчками */
  rowGap?: TSpaceAdaptive;

  /** Отступ между колонками */
  columnGap?: TSpaceAdaptive;

  /** ширина 100% */
  fullWidth?: boolean;
}

/** Компонент для создания grid сетки */
export const Grid = forwardRef<HTMLDivElement, IProps>(
  (
    {
      children,
      className,
      fullWidth,
      style,
      columns = '',
      gap = '',
      colStart = '',
      colEnd = '',
      rowStart = '',
      rowEnd = '',
      rows = '',
      alignItems = '',
      justifyContent = '',
      columnGap = '',
      rowGap = '',
    },
    ref,
  ) => {
    const { breakpoint } = useContext(BreakpointsContext);

    const classes = classnames(
      styled.root,
      className,
      ...getClasses(
        styled,
        { gap, rowGap, columnGap, columns, colStart, colEnd, rows, rowStart, rowEnd, alignItems, justifyContent },
        breakpoint,
      ),
      {
        [styled.fullWidth]: fullWidth,
      },
    );

    return (
      <div ref={ref} className={classes} style={style}>
        {children}
      </div>
    );
  },
);

Grid.displayName = 'Grid';
